import { lazyWithErrorHandle } from "@/utils/utils";
import type { RouterProps } from "../../../router/index";

const UserLayoutRoutes: RouterProps[] = [
  {
    path: `/user/login`,
    component: lazyWithErrorHandle(() => import("@/pages/Login")),
  },
  {
    path: `/user/repair`,
    component: lazyWithErrorHandle(() => import("@/pages/Repair")),
  },
  {
    path: `/user/googleLogin`,
    component: lazyWithErrorHandle(() => import("@/pages/LoginWithin")),
  },
  {
    path: `/user/googleLogin-Urisoku`,
    component: lazyWithErrorHandle(() => import("@/pages/LoginWithin")),
  },
  {
    path: `/user/googleLogin-Store`,
    component: lazyWithErrorHandle(() => import("@/pages/LoginWithin")),
  },
  {
    path: `/user/googleLogin-Earning`,
    component: lazyWithErrorHandle(() => import("@/pages/LoginWithin")),
  },
  {
    path: `/user/googleLogin-Development`,
    component: lazyWithErrorHandle(() => import("@/pages/LoginWithin")),
  },
  {
    path: `/user/googleLogin-Meeting`,
    component: lazyWithErrorHandle(() => import("@/pages/LoginWithin")),
  },
];

export default UserLayoutRoutes;
